import React from "react";
import PropTypes from "prop-types";

const BillingDetail = ({ title, name, address, email, contact }) => {
	const { lang } = global;

	return (
		<div className="flex flex-direction-column flex-gap-8">
			<h5 className="margin-bottom-0">
				<strong>
					{title}
				</strong>
			</h5>
			<p className="margin-bottom-0">
				<strong>{lang.t("Name")}: </strong>{name}
			</p>
			<p className="margin-bottom-0">
				<strong>{lang.t("Department Address")}: </strong>{address}
			</p>
			<p className="margin-bottom-0">
				<strong>{lang.t("Email")}: </strong>{email}
			</p>
			<p className="margin-bottom-0">
				<strong>{lang.t("Contact")}: </strong>{contact}
			</p>
		</div>
	);
}

BillingDetail.propTypes = {
	title: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	address: PropTypes.string.isRequired,
	email: PropTypes.string.isRequired,
	contact: PropTypes.string.isRequired,
};

export default BillingDetail;
